function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10ZM7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25ZM11.75 11C11.75 10.31 12.31 9.75 13 9.75C13.69 9.75 14.25 10.31 14.25 11C14.25 11.69 13.69 12.25 13 12.25C12.31 12.25 11.75 11.69 11.75 11ZM15.5 6C12.6 6 10.06 4.44 8.66 2.12C9.09 2.05 9.54 2 10 2C12.9 2 15.44 3.56 16.84 5.88C16.41 5.95 15.96 6 15.5 6ZM2.41992 7.47027C4.12992 6.50027 5.44992 4.92027 6.07992 3.03027C4.36992 4.00027 3.04992 5.58027 2.41992 7.47027ZM17.67 7.75957C17.88 8.46957 18 9.21957 18 9.99957C18 14.4096 14.41 17.9996 10 17.9996C5.59 17.9996 2 14.4096 2 9.99957C2 9.98252 2.00116 9.96546 2.0023 9.9488C2.00449 9.91663 2.00659 9.88593 2 9.85957C4.6 8.87957 6.69 6.86957 7.74 4.30957C9.58 6.55957 12.37 7.99957 15.5 7.99957C16.25 7.99957 16.97 7.90957 17.67 7.75957Z",
  fill: "#18CDA6",
  fillOpacity: 0.5
});

var SvgSocialFace = function SvgSocialFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocialFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/socialFace.82d6009e.svg";
export { ForwardRef as ReactComponent };